// extracted by mini-css-extract-plugin
export default {"updatePage":"UpdatePayroll_updatePage__QMCS0","updateContainer":"UpdatePayroll_updateContainer__zBnIF"};